export const dotSeparatorStyles = {
  width: '4px',
  height: '4px',
  borderRadius: '50%',
  backgroundColor: ({ palette }) => palette.text.placeholder,
};
